import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

const OrdersSettingsSkeletonShell = styled(SkeletonPageShell)``;

const OrdersSettingsSkeletonHeader = styled(SkeletonPageHeader)``;

const OrdersSettingsSectionSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
    gap: 32px;
    padding: 28px 0;
    border-bottom: 1px solid ${(props) => props.theme.app.borderColor};
    min-width: 0;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const OrdersSettingsCardGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    min-width: 0;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 700px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const OrdersSettingsCardSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 18px;
    min-width: 0;
`;

const OrdersSettingsFieldsSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
    min-width: 0;
`;

export const OrdersSettingsPageSkeleton: FC = () => (
    <OrdersSettingsSkeletonShell aria-hidden='true'>
        <OrdersSettingsSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(240px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(420px, 100%)' $height='13px' />
            </SkeletonStack>
        </OrdersSettingsSkeletonHeader>
        <OrdersSettingsSectionSkeleton>
            <SkeletonStack $gap='8px'>
                <SkeletonBlock $width='190px' $height='20px' />
                <SkeletonBlock $width='min(280px, 100%)' $height='12px' />
                <SkeletonBlock $width='min(220px, 100%)' $height='12px' />
            </SkeletonStack>
            <OrdersSettingsFieldsSkeleton>
                {Array.from({ length: 5 }).map((_, index) => (
                    <SkeletonRow key={index} $gap='8px'>
                        <SkeletonBlock $height='38px' $radius='6px' />
                        <SkeletonBlock $width='32px' $height='32px' $radius='4px' />
                    </SkeletonRow>
                ))}
            </OrdersSettingsFieldsSkeleton>
        </OrdersSettingsSectionSkeleton>
        <OrdersSettingsSectionSkeleton>
            <SkeletonStack $gap='8px'>
                <SkeletonBlock $width='190px' $height='20px' />
                <SkeletonBlock $width='min(280px, 100%)' $height='12px' />
                <SkeletonBlock $width='min(220px, 100%)' $height='12px' />
            </SkeletonStack>
            <OrdersSettingsCardGridSkeleton>
                {Array.from({ length: 3 }).map((_, index) => (
                    <OrdersSettingsCardSkeleton key={index}>
                        <SkeletonStack $gap='12px'>
                            <SkeletonBlock $width={index % 2 === 0 ? '130px' : '110px'} $height='18px' />
                            <SkeletonBlock $width='92%' $height='12px' />
                            <SkeletonBlock $width='72%' $height='12px' />
                            <SkeletonBlock $width='32px' $height='22px' $radius='11px' />
                        </SkeletonStack>
                    </OrdersSettingsCardSkeleton>
                ))}
            </OrdersSettingsCardGridSkeleton>
        </OrdersSettingsSectionSkeleton>
        <OrdersSettingsSectionSkeleton>
            <SkeletonStack $gap='8px'>
                <SkeletonBlock $width='160px' $height='20px' />
                <SkeletonBlock $width='min(280px, 100%)' $height='12px' />
            </SkeletonStack>
            <OrdersSettingsCardGridSkeleton>
                {Array.from({ length: 6 }).map((_, index) => (
                    <OrdersSettingsCardSkeleton key={index}>
                        <SkeletonStack $gap='12px'>
                            <SkeletonBlock $width={index % 2 === 0 ? '150px' : '120px'} $height='18px' />
                            <SkeletonBlock $width='90%' $height='12px' />
                            <SkeletonBlock $width='80px' $height='32px' $radius='6px' />
                        </SkeletonStack>
                    </OrdersSettingsCardSkeleton>
                ))}
            </OrdersSettingsCardGridSkeleton>
        </OrdersSettingsSectionSkeleton>
    </OrdersSettingsSkeletonShell>
);
